import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable, map} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {CanalModel} from '../model/canal/canal-model';
import {IdNome} from '../model/id-nome.model';
import {CanalOperadorModel} from '../model/canal/canal-operador.model';
import {diaSemanaDaApi, diaSemanaParaApi} from '../model/horario-funcionamento/horario-funcionamento.model';

@Injectable({
  providedIn: 'root'
})
export class CanalService {

  private readonly http = inject(HttpClient);

  private urlBase: string = environment.urlBase.concat('/canal');

  buscarTodosCanais(): Observable<CanalModel[]>{
    return this.http.get<CanalModel[]>(this.urlBase).pipe(map(canais => canais.map(canal => normalizarHorariosDaApi(canal))));
  }

  criarEditarCanal(canal: CanalModel): Observable<void> {
    return this.http.post<void>(`${this.urlBase}`, normalizarHorariosParaApi(canal));
  }

  buscarCanaisAtivoDoGrupo(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/ativos`)
  }

  buscarCanaisAtivoDoGrupoPeloContatoUsuario(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/ativos/tipo-usuario`)
  }

  buscarCanaisOperadores(): Observable<CanalOperadorModel[]>{
    return this.http.get<CanalOperadorModel[]>(`${this.urlBase}/buscar-canais-operadores`)
  }

  buscarCanaisVinculadosAoUsuario(): Observable<CanalModel[]>{
    return this.http.get<CanalModel[]>(`${this.urlBase}/buscar-canais-vinculados-usuario`).pipe(map(canais => canais.map(canal => normalizarHorariosDaApi(canal))));
  }


}

function normalizarHorariosDaApi(canal: CanalModel): CanalModel {
  return {
    ...canal,
    horariosFuncionamento: (canal.horariosFuncionamento ?? []).map(horario => ({
      ...horario,
      dias: (horario.dias ?? []).map(diaSemanaDaApi)
    }))
  };
}

function normalizarHorariosParaApi(canal: CanalModel): CanalModel {
  return {
    ...canal,
    horariosFuncionamento: (canal.horariosFuncionamento ?? []).map(horario => ({
      ...horario,
      dias: (horario.dias ?? []).map(dia => diaSemanaParaApi(dia))
    }))
  } as unknown as CanalModel;
}
